module.exports = __webpack_public_path__ + "img/emoji_21.0a2ea4f4.png";